import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import proDetails from '../components/productTable.vue';

formCreate.component('proDetails', proDetails);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      buttons: {
        submitAudit: true,
      },
      buttonText: {
        submitAudit: '暂存',
      },
      rule: [],
      formFunctionCode: 'details_form',
    };
  },
  async created() {
    await this.getFormRule('details_form', 'CRM20250521000000002');
  },
  methods: {
    // 设置规则
    setRule(item) {
      return item;
    },
    // 渲染完成后执行
    formComplete() {
      console.log('formConfig——————————', this.formConfig);
      const { code, row } = this.formConfig;
      if (code === 'view') {
        console.log(11112222);
        request.post('/dms/dmsterminalcontractorder/query', {
          id: row.id,
        }).then((res) => {
          const { result } = res;
          if (res.success) {
            this.setValue({
              ...result,
              totalAmountAll: result.totalAmount,
            });
          }
        });
      }
    },

    submit(btn) {

    },

  },
};
